import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import '../App2.css';

const DiferenciaModal = ({ isOpen, onRequestClose, onSubmit }) => {
    const [diferencia, setDiferencia] = useState(null);
    const [comentarioDiferencia, setComentarioDiferencia] = useState("");

    // Resetear el estado cuando se abra el modal
    useEffect(() => {
        if (isOpen) {
            setDiferencia(null);
            setComentarioDiferencia("");
        }
    }, [isOpen]);

    const handleConfirm = () => {
        if (diferencia === null) {
            toast.error("Debes seleccionar si hubo diferencias.");
            return;
        }

        if (diferencia === "Sí" && comentarioDiferencia.trim() === "") {
            toast.error("Si seleccionas 'Sí', debes ingresar un comentario.");
            return;
        }

        onSubmit(diferencia, comentarioDiferencia); // Enviar los valores al padre
        onRequestClose();
    };

    return (
        <Modal 
            isOpen={isOpen} 
            onRequestClose={onRequestClose} 
            className="modal-content" 
            overlayClassName="modal-overlay"
        >
            <h2>Al finalizar el trabajo ¿Hay diferencias en los resultados?</h2>
            <div>
                <label>
                    <input 
                        type="radio" 
                        value="Sí" 
                        checked={diferencia === "Sí"} 
                        onChange={() => setDiferencia("Sí")} 
                    /> Sí
                </label>
                <label>
                    <input 
                        type="radio" 
                        value="No" 
                        checked={diferencia === "No"} 
                        onChange={() => setDiferencia("No")} 
                    /> No
                </label>
            </div>
            {diferencia === "Sí" && (
                <textarea
                    placeholder="Describe las diferencias de los resultados..."
                    value={comentarioDiferencia}
                    onChange={(e) => setComentarioDiferencia(e.target.value)}
                />
            )}
            <div className="modal-buttons">
            <button 
                    className="confirm-button" 
                    onClick={handleConfirm} 
                    disabled={diferencia === null || (diferencia === "Sí" && comentarioDiferencia.trim() === "")}
                >
                    Confirmar envío
                </button>
                <button className="close-button" onClick={onRequestClose}>Cerrar</button>
            </div>
        </Modal>
    );
};

export default DiferenciaModal;